/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type PolarisAccessSettingsPageType from '@jira/spa-apps__polaris-settings-access/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyAccessSettingsPage: LazyComponent<{
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	(props: Record<string, any>): React.JSX.Element;
	displayName: string;
}> = // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PolarisAccessSettingsPageType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-polaris-settings-access", jiraSpaEntry: "async-polaris-ideas" */ '@jira/spa-apps__polaris-settings-access/src/index.tsx'
				),
			),
		{ ssr: false },
	);

export const AccessSettingsPage = (): React.JSX.Element => (
	<LazyPage
		Page={LazyAccessSettingsPage}
		pageId="async-polaris-settings-access"
		shouldShowSpinner={false}
	/>
);
